export default {
  // Days of the week — ConfiguratorDialog/ViewSection.vue selector
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',

  // Agenda view selector — IndexAgenda.vue
  agenda: {
    month: 'Month',
    week: 'Week',
    day: 'Day'
  }
}
